import { render, staticRenderFns } from "./newsfeed_m.vue?vue&type=template&id=0e375416&scoped=true&"
import script from "./newsfeed_m.vue?vue&type=script&lang=js&"
export * from "./newsfeed_m.vue?vue&type=script&lang=js&"
import style0 from "./newsfeed_m.vue?vue&type=style&index=0&id=0e375416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e375416",
  null
  
)

export default component.exports